import { useEffect, useState } from "react";
import { faqList } from "@/mocks/gossip";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TodayGossip from "./components/TodayGossip";
import BreakingCards from "./components/BreakingCards";
import HotTopics from "./components/HotTopics";
import Categories from "./components/Categories";
import DeepDive from "./components/DeepDive";
import Faq from "./components/Faq";
import About from "./components/About";
import ReportSection from "./components/ReportSection";
import Footer from "./components/Footer";

function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-lift transition-colors hover:bg-primary-500"
    >
      <i className="ri-arrow-up-line h-5 w-5 flex items-center justify-center" />
    </a>
  );
}

export default function Home() {
  const orgData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "99吃瓜",
    url: "https://hongtaishengshi.cn/",
    description:
      "99吃瓜专注于整理今日瓜点、最新爆料与热门事件的中文娱乐资讯平台。",
    areaServed: "中国",
  };

  const webSiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "99吃瓜 - 今日瓜点与最新爆料",
    url: "https://hongtaishengshi.cn/",
    inLanguage: "zh-CN",
    publisher: { "@type": "Organization", name: "99吃瓜" },
  };

  const webPageData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "99吃瓜 - 今日瓜点与最新爆料，实时更新热门事件",
    url: "https://hongtaishengshi.cn/",
    inLanguage: "zh-CN",
    isPartOf: { "@type": "WebSite", name: "99吃瓜", url: "https://hongtaishengshi.cn/" },
    description:
      "99吃瓜首页常驻实时更新的今日瓜点与最新爆料，热门话题按时间列出，不用在各大平台手动翻。",
  };

  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };

  return (
    <>
      <JsonLd data={orgData} />
      <JsonLd data={webSiteData} />
      <JsonLd data={webPageData} />
      <JsonLd data={faqData} />
      <Header />
      <main>
        <Hero />
        <TodayGossip />
        <BreakingCards />
        <HotTopics />
        <Categories />
        <DeepDive />
        <Faq />
        <About />
        <ReportSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}